.card {
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  width: 100%;
  height: 100%;
  border-radius: var(--border-radius-sm);
  background: var(--color-white);
  cursor: pointer;
  transition:
    transform 0.2s,
    box-shadow 0.2s;
}

.card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px var(--color-shadow-1);
}

.imageWrapper {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 160px;
}

.image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.content {
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 16px;
  gap: 8px;
}

.title {
  display: -webkit-box;
  overflow: hidden;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-semi-bold);
  text-overflow: ellipsis;
  white-space: normal;
  overflow-wrap: anywhere;
  color: var(--color-text-0);
}

.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.tag {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border: 1px solid var(--color-border-1);
  border-radius: var(--border-radius-xs);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  background: var(--color-white);
  color: var(--color-text-2);
}

.footer {
  display: flex;
  align-items: baseline;
  justify-content: flex-end;
  margin-top: auto;
}

.priceLabel {
  font-size: var(--font-size-sm);
  color: var(--color-text-2);
}

.price {
  flex: 0 0 auto;
}
